import { BrowserRouter, Routes, Route } from "react-router-dom";

import PublicRoutes from "./PublicRoutes";
import AdminRoutes from "./AdminRoutes";
import OrganizationRoutes from "./OrganizationRoutes";
import UserRoutes from "./UserRoutes";

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        {PublicRoutes()}
        {AdminRoutes()}
        {OrganizationRoutes()}
        {UserRoutes()}
      </Routes>
    </BrowserRouter>
  );
}